import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-label"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingDots',
    props: {
        label: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "loading-dots",
                role: "status",
                "aria-label": __props.label,
                "aria-live": "polite"
            }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", {
                        class: "loading-dots__dot",
                        "aria-hidden": "true"
                    }, null, -1),
                    _createElementVNode("div", {
                        class: "loading-dots__dot",
                        "aria-hidden": "true"
                    }, null, -1),
                    _createElementVNode("div", {
                        class: "loading-dots__dot",
                        "aria-hidden": "true"
                    }, null, -1)
                ]))], 8, _hoisted_1));
        };
    }
});
